module.exports = __webpack_public_path__ + "static/img/overview_active.13a5913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/overview_active.png
// module id = egA9
// module chunks = 1